import { ApplicationState } from '../'
import * as actions from '@lynx/client-core/src/store/profile/actions'
import { ThunkAction } from 'redux-thunk'
import { Action } from 'redux'
import { ProfileReturn } from '@lynx/client-core/src/api/interfaces'

export const { setLang } = actions
export const { changeProfileContextMenu } = actions

type clientLogout = (...args: Parameters<typeof actions.clientLogout>) => ThunkAction<Promise<void>, ApplicationState, null, Action<void>>
export const clientLogout = actions.clientLogout as unknown as clientLogout

type logout = (...args: Parameters<typeof actions.logout>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const logout = actions.logout as unknown as logout

type setEmail = (...args: Parameters<typeof actions.setEmail>) => ThunkAction<Promise<ProfileReturn>, ApplicationState, null, Action<string>>
export const setEmail = actions.setEmail as unknown as setEmail

type setDisplayName = (...args: Parameters<typeof actions.setDisplayName>) => ThunkAction<Promise<ProfileReturn>, ApplicationState, null, Action<string>>
export const setDisplayName = actions.setDisplayName as unknown as setDisplayName

type login = (...args: Parameters<typeof actions.login>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const login = actions.login as unknown as login

type loginCookie = (...args: Parameters<typeof actions.loginCookie>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const loginCookie = actions.loginCookie as unknown as loginCookie

type loginWithTokenId = (...args: Parameters<typeof actions.loginWithTokenId>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const loginWithTokenId = actions.loginWithTokenId as unknown as loginWithTokenId
